var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"col":"12"}},[_c('h3',[_vm._v("Unauthorized")])])],1),_c('v-row',[_c('v-col',{attrs:{"col":"12"}},[_vm._v(" Benutzer hat keine Rechte. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }